<template>
    <div
        class="t-main main" 
        @click.passive="handleMainContainerClick"
    >
        <ALoader
            v-if="mapLoading"
            style="z-index: 999"
        />
        <slot name="overlay"/>
        <!-- header has language dropdown with z-index > z-index of the ALoader -->
        <template>
            <slot name="header"/>
        </template>
        <div class="main__wrapper" role="main">
            <div class="main__container">
                <slot name="main"/>
                <OTMap :key="lastModified" />
            </div>
        </div>
        <slot name="footer"/>
        <slot name="modal" />
        <slot name="player" />
    </div>
</template>

<script>
import { mapState } from 'vuex';
    
import ALoader from '../../atoms/a-loader/a-loader';
import OTMap from '../../unique-organisms/o-t-map/o-t-map';

export default {
    name: 'TTerminal',
    components: {
        OTMap,
        ALoader
    },
    computed: {
        ...mapState({
            mapLoading: state => state.mapLoading,
            lastModified: state => state.lastModified,
        })
    },
    methods: {
        handleMainContainerClick() {
            this.$emit('onMainContainerClick', true);
        }
    }
}
</script>

<style lang="scss">
@import "t-terminal";
</style>
